import React from 'react';
import { processSteps } from '../data/mock';

const ProcessSection = () => {
  return (
    <section id="process" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative Lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Our Process</span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-6">
            How We Work
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            A proven methodology that delivers results every time.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-slate-200 via-teal-200 to-slate-200 transform -translate-y-1/2" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => (
              <div 
                key={step.step}
                className="relative group"
              >
                {/* Step Card */}
                <div className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2 relative z-10">
                  {/* Step Number */}
                  <div className="w-16 h-16 rounded-2xl bg-slate-900 group-hover:bg-teal-600 flex items-center justify-center mb-6 transition-all duration-300 mx-auto lg:mx-0">
                    <span className="text-2xl font-bold text-white">0{step.step}</span>
                  </div>
                  
                  <h3 className="text-xl font-semibold text-slate-900 mb-3 text-center lg:text-left">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-center lg:text-left">
                    {step.description}
                  </p>
                </div>

                {/* Arrow indicator for desktop */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                    <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
